import { Space } from 'antd';
import { useEffect, useState } from 'react';

import Select from '../../components/Select';
import NumericInput from '../../components/TextInput/NumericInput';

const CUSTOM_VALUE = '__custom__';

const InsuranceMonthlySelector = ({ onChange, userState, insuranceRatesData, disabled, t }) => {
  const [isCustom, setIsCustom] = useState(false);
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    setIsCustom(false);
    setSelectedValue();
  }, [userState]);

  const rawItems = insuranceRatesData?.documents || [];

  const updateFormValue = val => {
    if (typeof onChange === 'function') {
      onChange(val);
    }
  };

  if (rawItems.length === 0) {
    return <NumericInput min={1} onChange={updateFormValue} disabled={disabled} />;
  }

  const selectOptions = [
    ...rawItems.map(item => ({
      label: `${item.insuranceCompany} — ${item.amount}`,
      value: item.amount,
    })),
    { label: t('custom'), value: CUSTOM_VALUE },
  ];

  const handleSelectChange = val => {
    setSelectedValue(val);

    if (val === CUSTOM_VALUE) {
      setIsCustom(true);
      updateFormValue(undefined);
    } else {
      setIsCustom(false);
      updateFormValue(val);
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Select
        value={selectedValue}
        onChange={handleSelectChange}
        options={selectOptions}
        disabled={disabled}
      />
      {isCustom && <NumericInput min={1} onChange={updateFormValue} disabled={disabled} />}
    </Space>
  );
};

export default InsuranceMonthlySelector;
